import React from "react";
import { withLocalize } from "react-localize-redux";
import timeStampToDateFormat from "../../../utils/helpers/timestampToDateFormat";
import { BiTrash } from "react-icons/bi";
import { MdRestoreFromTrash } from "react-icons/md";

const ProjectCard = ({ project, onCardClicked, onDeleteClicked, onRestoreClicked, translate }) => {
  return (
    <div
      className="project-card d-flex flex-column align-items-center cursor--pointer position-relative"
      onClick={() => onCardClicked(project)}
    >
      <div className="logo rounded-circle overflow-hidden d-flex justify-content-center align-items-center cursor--default">
        {project.logo ? (
          <img
            src={project.logo}
            alt={`${project.name} Logo`}
            className="rounded-circle w-100"
          />
        ) : (
          project.name
            .split(" ")
            .map((word) => word.charAt(0))
            .join("")
            .substr(0, 2)
        )}
      </div>
      <h4 className="name text-center">{project.name}</h4>
      <span className="info-text">
        {translate("projects.project_card.companies")}: {project.companies}
      </span>
      <span className="info-text">
        {translate("projects.project_card.forms")}: {project.forms}
      </span>
      <span className="created-at text-center px-2">
        {translate("projects.project_card.created_at")}:{" "}
        {timeStampToDateFormat(project.created_at)}
      </span>
      {onDeleteClicked && (
        <span
          className="card-delete-btn position-absolute top-0 end-0"
          role="button"
          onClick={(e) => {
            e.stopPropagation();
            onDeleteClicked(project);
          }}
        >
          <BiTrash size={24} />
        </span>
      )}
      {onRestoreClicked && (
        <span
          className="card-restore-btn position-absolute top-0 end-0"
          role="button"
          onClick={(e) => {
            e.stopPropagation();
            onRestoreClicked(project);
          }}
        >
          <MdRestoreFromTrash size={24} />
        </span>
      )}
    </div>
  );
};

export default withLocalize(ProjectCard);
